<template>
    <div id="content" v-if="!loading">
        <div class="inner">
            <p class="buttons">
              <span v-if="$_updateActionAllowed">
              <span v-if="isReloadSet" class="pending_btn">
                <a
                    :class="['btn', 'btn_action', 'btn_grey', 'btn_refresh_cancel']"
                    :title="'Přenačíst všechna data' | translate"
                    @click.prevent.stop="executeMethod('refresh', false)"
                    v-translate>Zrušit přenačtení dat
                </a> {{$gettext('Naplánováno')}}
              </span>
              <a v-else
                  :class="['btn', 'btn_action', 'btn_grey', 'btn_refresh']"
                                      :title="'Přenačíst všechna data' | translate"
                  @click.prevent.stop="executeMethod('refresh', true)"
                  v-translate>Přenačíst všechna data
              </a>
              <span v-if="isSoftRestartSet" class="pending_btn">
                <a
                    :class="['btn', 'btn_action', 'btn_grey', 'btn_soft_reset_cancel']"
                    :title="'Soft reset' | translate"
                    @click.prevent.stop="executeMethod('softreset', false)"
                    v-translate>Zrušit soft reset
                </a>
                {{$gettext('Naplánováno')}}
              </span>
              <a v-else
                  :class="['btn', 'btn_action', 'btn_grey', 'btn_soft_reset']"
                                      :title="'Soft reset' | translate"
                  @click.prevent.stop="executeMethod('softreset', true)"
                  v-translate>Soft reset
              </a>
              <span v-if="isRestartSet" class="pending_btn">
                <a
                    class="btn btn_action btn_grey btn_reset_cancel"
                    :title="'Hard reset' | translate"
                    @click.prevent.stop="executeMethod('hardreset', false)"
                    v-translate>Zrušit hard reset
                </a>
                {{$gettext('Naplánováno')}}
              </span>
                <a v-else
                    class="btn btn_action btn_grey btn_reset"
                                        :title="'Hard reset' | translate"
                    @click.prevent.stop="executeMethod('hardreset', true)"
                    v-translate>Hard reset
                </a>
            </span>
              <DeviceLogViewerButton
                  v-if="$_loggedUser_action_allowed('deviceLogViewer', 'read')"
                  :url="this.deviceLogViewerUrl"
                  :mac-address="entity.last_used_mac_address"
                  :token="entity.device_token"
              />
            </p>
            <h1>{{ entity.name }} <span @click.stop="_showSubscriberDetatil" style="cursor: pointer;">| {{ entity.subscriber_name }}</span></h1>

        </div>
        <div class="responsiveTabs">
            <ul class="tabs">
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceDashboard'}">
                  <a @click.stop="openRoute('deviceDashboard')" v-translate>Dashboard</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceMacAddresses'}">
                  <a @click.stop="openRoute('deviceMacAddresses')" v-translate>Mac Adresy</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceActivity'}">
                  <a @click.stop="openRoute('deviceActivity')" v-translate>Aktivita zařízení</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceHistory'}">
                  <a @click.stop="openRoute('deviceHistory')" v-translate>Historie zařízení</a></li>
                <li v-if="$_loggedUser_action_allowed('channels')" :class="{'r-tabs-state-active' : this.$route.name === 'deviceChannels'}">
                  <a @click.stop="openRoute('deviceChannels')" v-translate>Programová skladba</a></li>
                <li v-if="$_loggedUser_action_allowed('channelGroups')" :class="{'r-tabs-state-active' : this.$route.name === 'deviceChannelGroups'}">
                  <a @click.stop="openRoute('deviceChannelGroups')" v-translate>Skupiny stanic</a></li>
                <li v-if="$_loggedUser_action_allowed('deviceBootConfigs')" :class="{'r-tabs-state-active' : this.$route.name === 'deviceDetailBootConfigs'}">
                  <a @click.stop="openRoute('deviceDetailBootConfigs')" v-translate>Konfigurace bootování</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceMetadata'}">
                  <a @click.stop="openRoute('deviceMetadata')" v-translate>Metadata</a></li>
            </ul>

            <keep-alive>
                <router-view
                    :entity="entity"
                    :isEditable="$_updateActionAllowed"
                    :availableDeviceProfiles="this.availableDeviceProfiles"
                    :methodCallLog="this.methodCallLog"
                    @reloadEntity="onReloadEntityRequest"
                />
            </keep-alive>

            <section class="buttons" v-if="$route.name === 'deviceDashboard'">
                <p>
                    <router-link
                        :to="{ name: moduleName }"
                        class="btn btn_back btn_seznam"
                        v-translate>Všechna zařízení
                    </router-link>
                    <input
                        v-if="$_updateActionAllowed"
                        type="submit"
                        :value="'Uložit zařízení' | translate"
                        :class="['btn']"
                        @click.prevent.stop="submitForm()"
                    />
                </p>
            </section>
        </div>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import devices from "@/components/views/devices/mixins/devices"
import DeviceLogViewerButton from "./detail/DeviceLogViewerButton.vue";

export default {
    name: "DeviceDetail",
    mixins: [
        detailActions,
        devices
    ],
    components: {DeviceLogViewerButton},
    data() {
        return {
            loading: true,
            prevRoute: null,
            availableDeviceProfiles: [],
            methodCallLog: [],
        }
    },
    created(DeviceService) {
        this.entityService = DeviceService
        this.createdInit()
    },
    beforeDestroy() {
        this.activateTab('settings')
    },
    computed: {
      isReloadSet(){
        return this.entity.reload;
      },
      isRestartSet(){
        return this.entity.restart == 'hard';
      },
      isSoftRestartSet(){
        return this.entity.restart == 'soft';
      }
    },
    methods: {
        _afterGetEntityActions(data) {
            this.availableDeviceProfiles = data.profiles;
            this.methodCallLog = data.method_call_log;
            this.deviceLogViewerUrl = data.device_log_viewer_url;
        },
        executeMethod(action, set) {
            switch (action) {
                case 'softreset':
                    this.entityService.restartDevices(this.entity.id, 'soft', set)
                        .then(() =>{
                          this.getEntity();
                          let message = set
                            ? this.$gettext('Zařízení bylo označeno k softrestartu.')
                              : this.$gettext('Softrestart zařízení byl odebrán.')
                          this.setSuccessMessage(this.$gettext(message));
                        })
                    break;
                case 'hardreset':
                    this.entityService.restartDevices(this.entity.id, 'hard', set)
                        .then(() =>{
                          this.getEntity();
                          let message = set
                              ? this.$gettext('Zařízení bylo označeno k hardrestartu.')
                              : this.$gettext('Hardrestart zařízení byl odebrán.')
                          this.setSuccessMessage(this.$gettext(message));
                        })
                    break;
                default:
                    this.entityService.forceFullReloadDevices(this.entity.id, set)
                        .then(() =>{
                          this.getEntity();
                          let message = set
                              ? this.$gettext('Zařízení bylo označeno k přenačtení dat.')
                              : this.$gettext('Přenačtení dat zařízení bylo zrušeno')
                          this.setSuccessMessage(this.$gettext(message));
                        })
            }
        },
        _showSubscriberDetatil() {
            this.$router.push({
                name: 'subscriberDetail',
                params: {
                    id: this.entity.id_subscriber
                }
            });
        },
        onReloadEntityRequest() {
            this.getEntity();
        }
    },
    watch: {
        '$route.params.id' (oldValue, newValue) {
            if (oldValue != newValue) {
                this.loading = true;
                this.createdInit();
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/devices/DeviceDetail.vue